import {
  IAuthAbsolutePath,
  IAuthInfoSuccessResponse,
} from '@amzn/work-spaces-web-client-core-lib';

/**
 * Enum to represent the different types of WarpDrive login flows
 */
export enum WarpDriveLoginType {
  WD_LOGIN = 'WD_LOGIN',
  UNIFIED_LOGIN = 'UNIFIED_LOGIN',
  HARD_BLOCK = 'HARD_BLOCK',
  UNKNOWN = 'UNKNOWN',
}

export const BLOCK_URL_BASE_LIST = [
  'connectivity.amazonworkspaces.com',
  'connectivity-gamma.amazonworkspaces.com',
];

/**
 * Error messages for different authentication scenarios
 * These are used for logging purposes only
 */
export const AuthErrorMessages = {
  [WarpDriveLoginType.WD_LOGIN]: {
    CSRF_INVALID: 'WD_LOGIN CSRF token validation failed',
    GENERAL: 'WD_LOGIN authentication error',
  },
  [WarpDriveLoginType.UNIFIED_LOGIN]: {
    CSRF_INVALID: 'UNIFIED_LOGIN CSRF token validation failed',
    GENERAL: 'UNIFIED_LOGIN authentication error',
  },
  [WarpDriveLoginType.UNKNOWN]: {
    CSRF_INVALID: 'UNKNOWN login type CSRF token validation failed',
    GENERAL: 'UNKNOWN login type authentication error',
  },
  GENERAL: 'General authentication error',
};

export interface IAuthCompleteStep {
  complete: true;
  external: false;
}

export interface IAuthInfoStep {
  complete: false;
  payload: IAuthInfoSuccessResponse;
}

export interface IAuthInternalStep {
  complete: false;
  external: false;
  url: IAuthAbsolutePath;
}

export interface IAuthExternalStep {
  complete: false;
  external: true;
  url: string;
}

export type INextAuthStep =
  | IAuthCompleteStep
  | IAuthInfoStep
  | IAuthInternalStep
  | IAuthExternalStep;
